import React, { memo } from 'react';

const QuoteDetailsLoadingState: React.FC = () => {
  return (
    <div>
      <div className="px-10 py-6 bg-loading/background-2">
        <div className="w-40 h-8 bg-system/white rounded-lg" />
      </div>
      <div className="bg-loading/background-1 p-10 h-60 space-y-6">
        {[
          'loading-detail-one',
          'loading-detail-two',
          'loading-detail-three',
        ].map((loadingDetailId: string) => (
          <div
            key={loadingDetailId}
            className="w-full flex items-center justify-between"
          >
            <div className="w-32 h-7 bg-loading/background-2 rounded-lg" />
            <div className="w-32 h-7 bg-loading/background-2 rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(QuoteDetailsLoadingState);
